
import { useCallback } from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/integrations/supabase/client';

export const useSweepstakesDraw = (fetchSweepstakes: () => Promise<void>) => {
  const { t } = useTranslationUtils();
  const { toast } = useToast();
  
  const runManualDraw = useCallback(async (id: string) => {
    try {
      const { data, error } = await supabase
        .rpc('run_sweepstakes_draw', { p_sweepstakes_id: id });
        
      if (error) throw error;
      
      if (data) {
        toast({
          title: t('admin.success'),
          description: t('admin.drawComplete'),
        });
        fetchSweepstakes();
      } else {
        toast({
          title: t('admin.warning'),
          description: t('admin.noEligibleEntries'),
          variant: 'destructive',
        });
      }
    } catch (error) {
      console.error('Error running sweepstakes draw:', error);
      toast({
        title: t('admin.error'),
        description: t('admin.errorRunningDraw'),
        variant: 'destructive',
      });
    }
  }, [t, toast, fetchSweepstakes]);

  return { runManualDraw };
};
